import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import ProfileSwitcher from "@/components/ProfileSwitcher";
import PlanBadge from "@/components/PlanBadge";

export default function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-[46px] sm:top-[42px] z-30 w-full backdrop-blur-md"
      style={{
        backgroundColor: "rgba(250, 247, 242, 0.85)",
        borderBottom: "1px solid #E5DEC9",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-2">
          <div
            className="w-9 h-9 rounded-xl grid place-items-center"
            style={{ backgroundColor: "#2D5A4C" }}
          >
            <Leaf size={18} color="white" />
          </div>
          <span className="font-serif-display text-xl sm:text-2xl font-semibold" style={{ color: "#1C2826" }}>
            Harmonix
          </span>
        </Link>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <PlanBadge />
              <ProfileSwitcher />
              <Button
                data-testid="logout-btn"
                variant="outline"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="rounded-full h-10 px-4"
              >
                <LogOut size={16} className="mr-1.5" /> Sign out
              </Button>
            </>
          ) : (
            <>
              <Button
                data-testid="header-login-btn"
                variant="ghost"
                onClick={() => navigate("/login")}
                className="rounded-full h-10 px-4"
              >
                Sign in
              </Button>
              <Button
                data-testid="header-register-btn"
                onClick={() => navigate("/register")}
                className="rounded-full h-10 px-5 btn-brand"
              >
                Get started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
